import React from "react";

export class SortableTable extends React.Component {
  constructor(props) {
    super(props);

    const initialSortBy = this.props.sort_by || this.props.initial_sort_by || null;
    // Default to desc for date columns (newest first)
    const isDateColumn = initialSortBy && (initialSortBy.includes('_at') || initialSortBy.includes('date') || initialSortBy.includes('expires'));

    this.state = {
      sort_by: initialSortBy,
      sort_direction: isDateColumn ? 'desc' : 'asc'
    }

    this.default_sort_function = this.default_sort_function.bind(this);
    this.set_sort_by = this.set_sort_by.bind(this);
    this.stable_sort = this.stable_sort.bind(this);
  }

  default_sort_function(a, b) {
    const aVal = a[this.state.sort_by];
    const bVal = b[this.state.sort_by];
    
    if (aVal === bVal) return 0;
    if (aVal == null) return 1;
    if (bVal == null) return -1;
    
    return aVal > bVal ? 1 : -1;
  }

  set_sort_by(e) {
    let sort_by = e.target.dataset.sort;
    let sort_direction = 'asc';
    
    if (this.state.sort_by === sort_by) {
      // Toggle direction if clicking the same column
      sort_direction = this.state.sort_direction === 'asc' ? 'desc' : 'asc';
    } else {
      // For date columns, start with desc (newest first)
      const template = this.props.row_templates.find(t => t.sort_by_property === sort_by);
      if (template && (sort_by.includes('_at') || sort_by.includes('date') || sort_by.includes('expires'))) {
        sort_direction = 'desc';
      }
    }
    
    this.setState({ sort_by, sort_direction });
  }

  stable_sort(array, compareFn) {
    // Create array of indices for stable sorting
    const indexed = array.map((item, index) => ({ item, index }));
    
    indexed.sort((a, b) => {
      const result = compareFn(a.item, b.item);
      // If items are equal, maintain original order
      return result !== 0 ? result : a.index - b.index;
    });
    
    return indexed.map(({ item }) => item);
  }

  render() {
    let rows = [...this.props.rows_data];
    let sort_by = this.props.sort_by || this.state.sort_by;
    
    if (sort_by) {
      const template = this.props.row_templates.find(t => t.sort_by_property === sort_by);
      let sort_function = template?.sort_function || this.default_sort_function;
      
      // Use stable sort
      rows = this.stable_sort(rows, (a, b) => {
        // Pass sort direction to sort function if it accepts it
        if (sort_function.length > 2) {
          return sort_function(a, b, this.state.sort_direction);
        }
        const result = sort_function(a, b);
        // Apply sort direction
        return this.state.sort_direction === 'desc' ? -result : result;
      });
    }

    let row_templates = this.props.row_templates || [];
    let table_style = { "--sortable-column-count": row_templates.length };

    return (
      <div className="sortable-table" style={table_style}>
        {row_templates.map((row_template, i) => {
          const isSorting = sort_by && sort_by === row_template.sort_by_property;
          const sortClass = isSorting ? ` sorting-by ${this.state.sort_direction}` : "";
          
          return (
            <div 
              data-sort={row_template.sort_by_property} 
              className={`sortable-table-cell header${sortClass}`}
              key={`header-${i}`} 
              onClick={this.set_sort_by}
            >
              {row_template.header_label}
            </div>
          );
        })}
        {rows.map((row, i) => (
          <div className="sortable-table-row" key={`row-${row.id || i}`}>
            {row_templates.map((row_template, j) => {
              let cell = row_template.render_cell(row);
              return (
                <div className="sortable-table-cell" key={`row-${row.id || i}-cell-${j}`}>
                  {cell}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    );
  }
}

export default SortableTable;
